var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-btn",
        { on: { click: _vm.exportCSV } },
        [_c("v-icon", [_vm._v("file_download")]), _vm._v(" CSV")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }